import React, {useState} from 'react';
import './Accordion.scss';
import {Collapse} from 'reactstrap';

const Accordion = ({title = '', children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className={`app-bg-gray mb-2 accordion ${isOpen && 'accordion-active'}`} onClick={toggle}>
      <div className="d-flex justify-content-between">
        <div className={`accordion-title ${isOpen ? 'font-weight-bold' : ''}`}>{title}</div>
        {isOpen ? 
          <span className="accordion-sign">&#45;</span>
        : <span className="accordion-sign">&#43;</span>}
      </div>
      <Collapse isOpen={isOpen}>
        <div className="pt-3 accordion-content">
          { children }
        </div>
      </Collapse>
    </div>
  );
}

export default Accordion;
